import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";

/**
 * Fronteira de erro de topo.
 *
 * Sem isto, qualquer exceção durante o render deixa a página EM BRANCO, sem
 * nada no ecrã e frequentemente sem nada no console — o modo de falha mais
 * caro de diagnosticar em produção.
 *
 * Escrita em HTML puro, sem componentes shadcn nem Tailwind: se o que rebentou
 * foi justamente a árvore de UI ou o CSS, o fallback tem de continuar a
 * funcionar.
 */
interface Estado {
  erro: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, Estado> {
  state: Estado = { erro: null };

  static getDerivedStateFromError(erro: Error): Estado {
    return { erro };
  }

  componentDidCatch(erro: Error, info: ErrorInfo) {
    console.error("Erro não capturado no render:", erro, info.componentStack);
  }

  render() {
    if (!this.state.erro) return this.props.children;

    return (
      <div
        style={{
          fontFamily: "system-ui, sans-serif",
          maxWidth: "42rem",
          margin: "4rem auto",
          padding: "0 1.5rem",
          lineHeight: 1.6,
        }}
      >
        <h1 style={{ fontSize: "1.25rem", marginBottom: "0.5rem" }}>
          A aplicação encontrou um erro
        </h1>
        <p style={{ color: "#666" }}>
          Recarregar a página costuma resolver. Se persistir, envie a mensagem
          abaixo a quem mantém o sistema.
        </p>
        <pre
          style={{
            background: "#f5f5f5",
            color: "#111",
            padding: "1rem",
            borderRadius: "0.5rem",
            overflowX: "auto",
            fontSize: "0.8125rem",
          }}
        >
          {this.state.erro.message}
        </pre>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: "0.5rem 1rem",
            borderRadius: "0.5rem",
            border: "1px solid #ccc",
            background: "#fff",
            cursor: "pointer",
          }}
        >
          Recarregar
        </button>
      </div>
    );
  }
}
